import Flex from "@/shared/components/common/Flex";
import Typography from "@/shared/components/common/Typography";
import { cn } from "@/shared/libs/commonUtils";
import type { ReactNode } from "react";

interface HotelCardBadgeProps {
  message?: string;
  className?: string;
  position?: "left" | "right";
  children?: ReactNode;
}

export default function HotelCardBadge({
  message,
  className,
  position = "right",
  children,
}: HotelCardBadgeProps) {
  return (
    <Flex
      className={cn(
        "absolute top-0 translate-y-2 z-1 bg-background rounded-full p-1 px-2 shadow-2",
        position === "left" ? "left-0 translate-x-2" : "right-0 -translate-x-2",
        className,
      )}
      direction={"row"}
      gap={"1"}
      justifyContent={"between"}
      alignItems={"center"}
    >
      {message && (
        <Typography
          variant="caption"
          fontWeight="normal"
          className="text-primary"
        >
          {message}
        </Typography>
      )}
      {children && children}
    </Flex>
  );
}
